import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProtocolEntryDto } from '@interfaces/interfaces';
import { environment } from 'src/environments/environment';
import { ProtocolFilterDto } from '@api/projects/interfaces';

@Injectable({
	providedIn: 'root',
})
export class ProtocolRestService {
	
	constructor(private httpClient: HttpClient) { }
	
	getProtocolEntries$(projectID: string, filter: ProtocolFilterDto): Observable<ProtocolEntryDto[]> {
		const url = `${environment.serverEndpoint}/api/projects/${projectID}/protocol`;
		return this.httpClient.post<ProtocolEntryDto[]>(url, filter);
	}
}
